import { defineAction, object, string, type ActionDefinition } from '~/prix'
import { appSebraeAttendanceExpression } from '~/packages/appSebrae/stats/appSebraeAttendanceStats.definition'
import agentPolygonSmartMappingServiceAreaAction from './agentPolygonSmartMappingServiceArea.action.json' with { type: 'json' }

const agentPolygonSmartMappingServiceAreaDefinition = defineAction({
  ...(agentPolygonSmartMappingServiceAreaAction as ActionDefinition<'python312'>),
  input: object({
    agentCpf: string(),
    startDate: string().isOptional(),
    endDate: string().isOptional(),
    cacheKey: string().isOptional(),
    filter: appSebraeAttendanceExpression.isOptional(),
  }),
  output: object<any>({}),
  cache: () => {
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24,
        expirationMsForUpdate: 1000 * 60 * 30,
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24,
        expirationMsForUpdate: 1000 * 60 * 30,
      },
    }
  },
  cacheKey: ({ agentCpf, startDate, endDate, cacheKey, filter }) => {
    const filterStr = filter ? JSON.stringify(filter) : ''
    return `${agentCpf}-${startDate || ''}-${endDate || ''}-${cacheKey || ''}-${filterStr}`
  },
})

export default agentPolygonSmartMappingServiceAreaDefinition
